import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Email from "@material-ui/icons/Email";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CircularProgress from "@material-ui/core/CircularProgress";


import { authService } from "api/axios";
import { APP_CLIENT_ID, APP_CLIENT_SECRET } from "context/AuthContext";


const useStyles = makeStyles(styles);
import styles from "assets/jss/material-dashboard-pro-react/views/forgotPasswordPageStyle";


const FORGOT_PASSWORD_URL = 'api/forgotPassword';
const GET_CLIENT_TOKEN_URL = '/api/getClientToken?client_id=';

export default function ForgotPasswordPage() {
    const history = useHistory();
    const [cardAnimation, setCardAnimation] = useState("cardHidden");
    const [email, setEmail] = useState("");
    const [clientToken, setClientToken] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    React.useEffect(() => {
        let id = setTimeout(function () {
            setCardAnimation("");
        }, 700);
        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);
        };
    });

    useEffect(() => {
        const controller = new AbortController();

        const getClientToken = async () => {
            try {
                const credentials = btoa(`${APP_CLIENT_ID}:${APP_CLIENT_SECRET}`);
                const response = await authService.get(GET_CLIENT_TOKEN_URL + "8", {
                    headers: {
                        Authorization: `Basic ${credentials}`,
                    },
                });
                setClientToken(response.data.token);
            } catch (error) {
                console.error("Error fetching client token", error);
            }
        };

        getClientToken();

        return () => {
            controller.abort();
        };
    }, []);

    const handleReset = async () => {
        setLoading(true);
        try {
            const payload = {
                clientId: "8",
                emailAddress: email,
            };
    
            await authService.post(FORGOT_PASSWORD_URL, payload, {
                headers: { Authorization: `Bearer ${clientToken}` },
            });

            setSuccessMsg("If your email is in our database, you'll receive a code to reset your password.");
            setLoading(false);
            history.push("/auth/reset-password");
        } catch (error) {
            console.error("Forgot Password Error", error);
            if (!error?.response) {
                setErrMsg("No Server Response");
            } else if (error.response?.status === 400) {
                setErrMsg("Invalid request. Check your input.");
            } else if (error.response?.status === 401) {
                setErrMsg("Unauthorized. Please try again.");
            } else if (error.response?.status === 404) {
                setErrMsg("Email not found. Please check and try again.");
            } else {
                setErrMsg("Reset Failed. Please try again later.");
            }
            setLoading(false);
        }
    };

    const classes = useStyles();
    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={6} md={4}>
                    <form>
                        <Card login className={classes[cardAnimation]}>
                            <CardHeader
                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                color="warning"
                            >
                                <h3 className={classes.cardTitle}>Forgot Password</h3>
                                <div className={classes.socialLine}>
                                    <h4>Enter your email to reset your password</h4>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {successMsg && <p style={{ color: "green", fontWeight: "bold" }}>{successMsg}</p>}
                                {errMsg && <p style={{ color: "red" }}>{errMsg}</p>}
                                <CustomInput
                                    labelText="Email..."
                                    id="email"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        type: "email",
                                        value: email,
                                        onChange: (e) => setEmail(e.target.value),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Email className={classes.inputAdornmentIcon} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </CardBody>
                            <CardFooter className={classes.justifyContentCenter}>
                                {loading ? (
                                    <CircularProgress color="secondary" />
                                ) : (
                                    <Button color="warning" simple size="lg" block onClick={handleReset}>
                                        Reset Password
                                    </Button>
                                )}
                            </CardFooter>
                        </Card>
                    </form>
                </GridItem>
            </GridContainer>
        </div>
    );
}
